import { useLocalStorageState } from "@sundae/react-hooks";
import { useWalletLoadingState, useWalletObserver } from "@sundaeswap/wallet-lite";
import { LOCAL_CHECK_VOTE_SIG } from "../constants/localStorage";
export const useDelegationKey = () => {
    const { stakeAddress } = useWalletObserver();
    const { ready } = useWalletLoadingState();
    const [storedKey, saveStoredKey, clearStoredKey] = useLocalStorageState(`${LOCAL_CHECK_VOTE_SIG}_${btoa(stakeAddress)}`, false);
    return {
        loaded: ready,
        storedKey,
        saveStoredKey,
        clearStoredKey,
    };
};
//# sourceMappingURL=useDelegationKey.js.map